<template>
    <div>
      <div class="p404 bg-cercles">
        <div class="p404__content">
          <img
            class="p404__favicon"
            src="../assets/img/logos/favicon.svg"
            alt=""
          />
          <h2 class="p404__title">{{ $t("pages.errorTitle") }}</h2>
          <h4 class="p404__subtitle">
            {{ $t("pages.errorSubtitle") }}
          </h4>
        </div>
      </div>
    </div>
</template>
  
<script>
export default {
  name: "Error",
  metaInfo() {
    return {
      title:  this.$t("pages.errorMetaTitle") + " | HelloBB",
      meta: [
         { name: "description", content: this.$t("pages.errorMetaDescription") },
         { name: "robots", content: "noindex"}
      ],
    };
  },
};
</script>
